import { Actor, Color, ScreenElement, vec, Vector, Text, Canvas, Label, Font, BaseAlign, TextAlign, Graphic, Engine, FontStyle, ActorArgs, Sprite } from "excalibur";
import { Resources } from "../../resources";
import { LevelOne } from "../../scenes/level-one/level-one";
import { playStart } from "../../util";
import { TowerSpec } from "./tower_specs";

const padding = 8;

export class CostButton extends ScreenElement {
    private selected = false;
    private selectionHighlight?: ScreenElement = null;
    private currentHighlight: 'select' | 'unavailable' | null = null;

    constructor(
        protected level: LevelOne,
        protected cost: number,
        protected onSelect: () => void,
        args: ActorArgs
    ) {        
        super(args);
    }

    public onInitialize() {
        this.on('pointerup', () => {
            if (this.level.money >= this.cost) {
                this.onSelect();
            }
        });

        this.graphics.use(new Sprite({
            image: Resources.button,
            destSize: {
                width: this.width,
                height: this.height
            }
        }));
    }

    public onPostUpdate(engine: Engine, delta: number) {
        let desiredHighlight = null;

        if (this.selected) {
            desiredHighlight = 'select';
        } else if (this.level.money < this.cost) {
            desiredHighlight = 'unavailable';
        }

        if (desiredHighlight !== this.currentHighlight) {
            this.setHighlight(desiredHighlight);
        }
    }

    public setSelected(selected: boolean) {
        this.selected = selected;
    }

    private setHighlight(mode: 'select' | 'unavailable' | null) {
        this.currentHighlight = mode;

        let color: Color;

        switch (mode) {
            case 'select':
                color = new Color(255, 255, 255, 0.3);
                break;
            case 'unavailable':
                color = new Color(0, 0, 0, 0.5);
                break;
            default:
                color = Color.Transparent
        }

        if (this.selectionHighlight) {
            this.removeChild(this.selectionHighlight)
        }

        const selectionPadding = 0;

        this.selectionHighlight = new ScreenElement({
            pos: vec(selectionPadding, selectionPadding),
            width: this.width - selectionPadding * 2,
            height: this.height - selectionPadding * 2,
            color
        });
        this.addChild(this.selectionHighlight);
    }

}